import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import { ShieldCheck, Lock, Mail, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("admin@smartdream.it");
  const [password, setPassword] = useState("admin123");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      const from = loc.state?.from?.pathname || "/admin";
      nav(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.detail || err.message || "Errore");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background:
          "radial-gradient(800px 400px at 50% -10%, rgba(20,194,161,0.2), transparent 60%), #0b1114",
      }}
    >
      <div className="w-full max-w-[420px]">
        <div className="flex items-center gap-3 mb-8">
          <div
            className="w-11 h-11 rounded-xl flex items-center justify-center"
            style={{
              background: "linear-gradient(155deg,#12b096,#0a8670)",
              boxShadow: "0 10px 24px -10px rgba(20,194,161,0.5)",
            }}
          >
            <ShieldCheck size={22} className="text-white" />
          </div>
          <div>
            <div className="text-white text-xl font-semibold tracking-tight">
              SmartDream Console
            </div>
            <div className="text-white/50 text-xs">Admin Backoffice</div>
          </div>
        </div>

        <form
          onSubmit={submit}
          className="rounded-2xl border border-white/10 bg-white/[0.03] p-6"
        >
          <label className="text-white/70 text-[11px] uppercase tracking-wider">
            Email
          </label>
          <div className="mt-1 flex items-center h-11 px-3 gap-2 rounded-xl bg-white/5 border border-white/10 focus-within:border-[#14c2a1]">
            <Mail size={14} className="text-white/50" />
            <input
              type="email"
              data-testid="admin-login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-transparent text-white text-sm focus:outline-none"
            />
          </div>
          <label className="mt-4 block text-white/70 text-[11px] uppercase tracking-wider">
            Password
          </label>
          <div className="mt-1 flex items-center h-11 px-3 gap-2 rounded-xl bg-white/5 border border-white/10 focus-within:border-[#14c2a1]">
            <Lock size={14} className="text-white/50" />
            <input
              type="password"
              data-testid="admin-login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="flex-1 bg-transparent text-white text-sm focus:outline-none"
            />
          </div>
          {error && (
            <div className="mt-3 text-rose-300 text-sm bg-rose-500/10 border border-rose-400/20 rounded-lg px-3 py-2">
              {error}
            </div>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="mt-5 w-full h-11 rounded-xl text-white font-semibold text-sm flex items-center justify-center gap-2 disabled:opacity-60 transition-all"
            style={{
              background: "linear-gradient(155deg,#12b096,#0a8670)",
              boxShadow: "0 12px 28px -12px rgba(20,194,161,0.55)",
            }}
          >
            {loading && <Loader2 size={14} className="animate-spin" />}
            Accedi alla console
          </button>
          <div className="mt-4 text-white/40 text-[11px] text-center">
            Account demo pre-compilato
          </div>
        </form>
      </div>
    </div>
  );
}
